const main = () => {

    const cards = document.querySelectorAll('.c-cards-voice');
    const modal = document.getElementById('voice-modal');
    const modalBody = document.getElementById('voice-modal-body');
    const closeBtn = document.querySelector('.c-modal__close');
    const overlay = document.querySelector('.c-modal__overlay');

    if (cards.length) {
        cards.forEach(card => {
            card.addEventListener('click', () => {

                // クローンして中身を表示
                const clone = card.cloneNode(true);

                // ボタンとか不要なら削除
                const moreBtn = clone.querySelector('.c-cards-voice__more');
                if (moreBtn) moreBtn.remove();

                modalBody.innerHTML = '';
                modalBody.appendChild(clone);
                modal.classList.add('is-open');
            });
        });

        const closeModal = () => {
            modal.classList.remove('is-open');
        };

        closeBtn.addEventListener('click', closeModal);
        overlay.addEventListener('click', closeModal);
    }
}


export default main;
